import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Event from "../components/Event";
import { useDispatch, useSelector } from "react-redux";

function PlayReply() {
    // const dispatch = useDispatch();
    // const navigate = useNavigate();

    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const sportCategory = params.get("sportCategory");
    const eventId = params.get("eventId");
    const team1Idx = params.get("team1Idx");
    const startPos = params.get("startPos");
    const primaryColor = params.get("primaryColor");
    const secondaryColor = params.get("secondaryColor");
    const editPrimaryTeam = params.get("editPrimaryTeam");
    const isFree = params.get("isFree");
    const payout = params.get("payout");
    const point = params.get("point");
    const closetScorePair = params.get("closetScorePair");
    const playerNames = params.get("playerNames");
    const player1Name = params.get("player1Name");
    const player2Name = params.get("player2Name");
    const player3Name = params.get("player3Name");
    const player4Name = params.get("player4Name");

    const [tabStatus, setTabStatus] = useState(false);

    // const style = {
    //   menuContent: {
    //     position: 'absolute',
    //     display: 'inline-block',
    //     right: 11,
    //     top: 15
    //   },
    //   menuContentItem: {
    //     width: 20,
    //     height: 3,
    //     backgroundColor: secondaryColor,
    //     margin: '5px 0'
    //   }
    // }

    //   console.log(closetScorePair.split(',').map(Number), 'closetScorePair in player Game page')
    const handleTab = () => {
        setTabStatus(!tabStatus);
    };

    // const handleGame = () => {
    //   navigate('/activeGames')
    // }

    // console.log(isFree, 'Free in reply page')
    return (
        <>
            <Event
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                tabStatus={tabStatus}
                sportCategory={sportCategory}
                team1Idx={team1Idx}
                startPos={startPos}
                eventId={eventId}
                editPrimaryTeam={editPrimaryTeam}
                isFree={isFree || false}
                payout={payout}
                point={point}
                closetScorePair={closetScorePair?.split(",").map(Number) || []}
                playerNames={playerNames?.split(",") || []}
                handleTab={handleTab}
                player1Name={player1Name}
                player2Name={player2Name}
                player3Name={player3Name}
                player4Name={player4Name}
            />
        </>
    );
}

export default PlayReply;
